module.exports = __webpack_public_path__ + "static/media/HOTEL PICS (17).02abb842.png";